export const whatIsYourObjective = [
  {
    value: 'Yes',
    label: 'Yes',
  },{
    value: 'No',
    label: 'No',
  },{
    value: 'Maybe',
    label: 'Maybe',
  },
];
